import { SEARCH_SET } from "./actions";
import { Action, reducerFn, ReducerState } from "../../helpers/reducers";

interface Search {
    text: string;
}
type SearchAction = Action<Search>;

const initialState: Search = {
    text: "",
};

const fnMap = {
    [SEARCH_SET]: (s: ReducerState, a: SearchAction) =>
        s.set("text", a.payload),
};
export const searchReducer = reducerFn("search", initialState, fnMap);
